import React from "react";
import "./ContactUs.css";
import Footer from "./Footer";
import { Link } from "react-router-dom";

const ContactUs = () => {
  return (
    <div className="cu-page">
     <div className="cu-logo-container">
  <Link to="/home"><img src={`${process.env.PUBLIC_URL}/${process.env.REACT_APP_APP_LOGO}`} alt="Logo" className="cu-logo" /></Link>
</div>
      <div className="cu-main">
        <div className="cu-contact-section">

          <div className="cu-contact-left">
            <p className="cu-contact-label">Get in Touch</p>
            <h1 className="cu-contact-heading">
              Contact<br /><span className="cu-contact-heading-accent">Us</span>
            </h1>
            <p className="cu-contact-subtext">Have a question, business inquiry, media request, or need support with VH2 Networks?
              Email is the fastest way to reach us.
            </p>
            <p className="cu-contact-subtext">For all general questions, partnership inquiries, content submissions, advertising, and support requests, please contact us by email.</p>
          </div>

          <div className="cu-contact-divider" />

          <div className="cu-contact-right">
            <p className="cu-contact-email-label">Email:</p>
            <a href="mailto:info@vh2networks.com" className="cu-contact-email-link">info@vh2networks.com</a>

            <div className="cu-contact-address">
              <p className="cu-contact-address-label">Mailing Address:</p>
              <p className="cu-contact-subtext">VH2 Networks<br />PO Box 1256<br />Cumming, GA 30028</p>
            </div>
          </div>

        </div>
      </div>

      <Footer />
      <div className="cu-footer-copy">
        © {new Date().getFullYear()} All Rights Reserved.
      </div>
    </div>
  );
};

export default ContactUs;